export interface AssessmentFooterPage<T> {
    items: T[];
    total: number;
    authors: string[];
    page: number;
    pageSize: number;
}

export interface AssessmentFooterPageQuery {
    page: number;
    pageSize: number;
    search: string;
    authors: string[];
}

export function readAssessmentFooterPage<T>(value: AssessmentFooterPage<T> | undefined,
    query: AssessmentFooterPageQuery): AssessmentFooterPage<T> {
    if (!value || !Array.isArray(value.items) || value.items.length > query.pageSize ||
        !Number.isSafeInteger(value.total) || value.total < 0 ||
        value.page !== query.page || value.pageSize !== query.pageSize ||
        !Array.isArray(value.authors) || value.authors.some(name => typeof name !== 'string')) {
        throw new Error('Unable to load assessment footer page.');
    }
    return value;
}
